export const SUCCESS_DEFAULT = 'neo-trading/dashboard/SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'neo-trading/dashboard/FAILURE_DEFAULT';
export const LOAD_CHANGE_PASSWORD = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD';
export const LOAD_CHANGE_PASSWORD_SUCCESS = 'neo-trading/auth/LOAD_CHANGE_PASSWORD_SUCCESS';
export const LOAD_CHANGE_PASSWORD_FAILURE = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_FAILURE';
//export const LOAD_CHANGE_PASSWORD = 'neo-trading/auth/LOAD_CHANGE_PASSWORD';
//export const LOAD_CHANGE_PASSWORD_FAILURE = 'neo-trading/auth/LOAD_CHANGE_PASSWORD_FAILURE';
export const LOAD_CHANGE_PASSWORD_SETTING = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SETTING';
export const LOAD_CHANGE_PASSWORD_SETTING_SUCCESS = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SETTING_SUCCESS';
export const LOAD_CHANGE_PASSWORD_SETTING_FAILURE = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SETTING_FAILURE';
export const BLANK_MSG = 'neo-trading/dashboard/BLANK_MSG';
import * as types from "../constants/changePasswordConstants";

// export function loadchangePassword() {
//   return {
//     types: [types.LOAD_CHANGE_PASSWORD, types.LOAD_CHANGE_PASSWORD_SUCCESS, types.LOAD_CHANGE_PASSWORD_FAILURE],
//     promise: (client) => client.get('/change_password', {})
//   };
//  }
 export function changePassword(user) {
   return {
    type: LOAD_CHANGE_PASSWORD, 
    user,
    promise: (client) => client.post('/resetPwd', {
    	data: {
    	   	OPWD: user.oldpass,
            NPWD: user.newpass,
            RST:false,
            UID:JSON.parse(localStorage.getItem('user')).UID,
            UT:"T"
      }
    })
  };
 }
 export function changePasswordSetting(user) {
   return {
    type: LOAD_CHANGE_PASSWORD_SETTING,
    user,
    promise: (client) => client.post('/resetPwd', {
       data: {
    	   	OPWD: user.oldpass,
            NPWD: user.newpass,
            RST:false,
            UID:JSON.parse(localStorage.getItem('user')).UID,
            UT:"T"
      }
    })
  };
 }
export function blankMsg(){
  return{
    type:BLANK_MSG,
  }
}

export function forgotPassword (form) {
  return {
    type: types.FORGOT_PASS,
    form,
    promise: (client) => client.post('/validateUserCode', {
      header: {
        location: form.companyCode
      },
      data: {
        userCode: form.traderCode,
        userType: 'Trd'
      }
    })
  }
}

export function resendOTP (form) {
  return {
    type: types.RESEND_OTP,
    form,
    promise: (client) => client.post('/resendOTP', {
      header: {
        location: form.companyCode
      },
      data: {
        userCode: form.traderCode,
        userType: 'Trd'
      }
    })
  }
}

export function verifyOTP (form) {
  return {
    type: types.VERIFY_OTP, 
    form,
    promise: (client) => client.post('/validatePasswordOTP', {
      header: {
        location: form.companyCode
      },
      data: {
        userCode: form.traderCode,
        OTP: form.OTP
      }
    })
  }
}

export function resetPassword (form) {
  return {
    type: types.RESET_PASSWORD, 
    form,
    promise: (client) => client.post('/resetUserPassword', {
      header: {
        location: form.companyCode
      },
      data: {
        userCode: form.traderCode,
        newPassword: form.password,
        userType: 'Trd'
      }
    })
  }
}

export function closeModal () {
  return {
    type: types.CLOSE_MODAL
  }
}